var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "base-info-container" },
    [
      _c(
        "el-card",
        {
          scopedSlots: _vm._u([
            {
              key: "header",
              fn: function() {
                return [_c("TitleItem", { attrs: { title: "基本信息" } })]
              },
              proxy: true
            }
          ])
        },
        [
          _c(
            "el-form",
            {
              ref: "baseInfoForm",
              attrs: {
                model: _vm.baseInfoModel,
                rules: _vm.rules,
                "label-width": "125px"
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "套餐分类", required: "" } },
                [
                  _vm.cateModel
                    ? [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.cateModel.classificationFullName) + "  "
                          )
                        ]),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: { click: _vm.changeCate }
                          },
                          [_vm._v(" 修改类目")]
                        )
                      ]
                    : _c(
                        "el-button",
                        {
                          attrs: { type: "text" },
                          on: { click: _vm.changeCate }
                        },
                        [_vm._v("选择类目")]
                      ),
                  _c("p", { staticClass: "cate-tips" }, [
                    _vm._v(
                      "准确选择货品分类有助于完善货品信息和精准推送到商城分类"
                    )
                  ])
                ],
                2
              ),
              _c(
                "el-form-item",
                { attrs: { label: "套餐名称", prop: "name" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "203px" },
                    attrs: {
                      maxlength: "30",
                      placeholder: "请输入套餐名称(至多30字)"
                    },
                    model: {
                      value: _vm.baseInfoModel.name,
                      callback: function($$v) {
                        _vm.$set(_vm.baseInfoModel, "name", $$v)
                      },
                      expression: "baseInfoModel.name"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "自定义分类" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择自定义分类" },
                      model: {
                        value: _vm.baseInfoModel.goodsType,
                        callback: function($$v) {
                          _vm.$set(_vm.baseInfoModel, "goodsType", $$v)
                        },
                        expression: "baseInfoModel.goodsType"
                      }
                    },
                    _vm._l(_vm.customCateList, function(cateItem) {
                      return _c("el-option", {
                        key: cateItem.shopDecorateId,
                        attrs: {
                          label: cateItem.name,
                          value: cateItem.shopDecorateId
                        }
                      })
                    }),
                    1
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "mar10-l",
                      attrs: { type: "text" },
                      on: { click: _vm.toShopClassify }
                    },
                    [_vm._v("新建自定义分类")]
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "套餐商品", required: "" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "text" },
                      on: { click: _vm.selectGoodsList }
                    },
                    [_vm._v("选择商品")]
                  ),
                  _vm.checkGoodsList.length
                    ? _c(
                        "el-table",
                        {
                          ref: "multipleTable",
                          staticClass: "mar20_b",
                          staticStyle: { width: "100%" },
                          attrs: {
                            data: _vm.checkGoodsList,
                            "tooltip-effect": "dark"
                          },
                          on: { "selection-change": _vm.handleSelectionChange }
                        },
                        [
                          _c("el-table-column", {
                            attrs: { type: "selection", width: "55" }
                          }),
                          _c("el-table-column", {
                            attrs: { label: "商品信息", width: "300" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "client_list_wrap" },
                                        [
                                          _c(
                                            "ul",
                                            {
                                              staticClass: "clear",
                                              staticStyle: { width: "670px" }
                                            },
                                            [
                                              _c(
                                                "li",
                                                {
                                                  staticStyle: {
                                                    width: "300px"
                                                  }
                                                },
                                                [
                                                  _c("img", {
                                                    staticClass:
                                                      "float-left appoint_good_img",
                                                    staticStyle: {
                                                      width: "80px",
                                                      height: "80px",
                                                      "border-radius": "5px",
                                                      "margin-right": "10px"
                                                    },
                                                    attrs: {
                                                      src: scope.row.picUrl,
                                                      alt: ""
                                                    }
                                                  }),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        width: "250px"
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "ellipsis f14"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              scope.row.name
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              1378985332
                            )
                          }),
                          _c("el-table-column", {
                            attrs: {
                              prop: "marketPriceStr",
                              label: "市场价",
                              width: "90"
                            }
                          }),
                          _c("el-table-column", {
                            attrs: { label: "套餐内价格", width: "150" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c(
                                        "el-input",
                                        {
                                          on: {
                                            blur: function($event) {
                                              scope.row.groupGoodsPrice = _vm.formatNums(
                                                scope.row.groupGoodsPrice,
                                                true
                                              )
                                            },
                                            change: function($event) {
                                              return _vm.countPrice()
                                            }
                                          },
                                          model: {
                                            value: scope.row.groupGoodsPrice,
                                            callback: function($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "groupGoodsPrice",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "scope.row.groupGoodsPrice"
                                          }
                                        },
                                        [
                                          _c("template", { slot: "prepend" }, [
                                            _vm._v("￥")
                                          ])
                                        ],
                                        2
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              66870286
                            )
                          }),
                          _c("el-table-column", {
                            attrs: { label: "操作" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: { type: "text" },
                                          on: {
                                            click: function($event) {
                                              return _vm.deleteRow(
                                                scope.$index,
                                                _vm.checkGoodsList
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("删除")]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              532508782
                            )
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.checkGoodsList.length > 0
                    ? _c("div", { staticClass: "hejimoney flex" }, [
                        _c("span", { staticClass: "hejimoneyspan" }, [
                          _vm._v(
                            "合计：" + _vm._s(_vm.checkGoodsList.length) + "件"
                          )
                        ]),
                        _c("span", [
                          _vm._v("套餐价格合计：" + _vm._s(_vm.marketPrice))
                        ])
                      ])
                    : _vm._e(),
                  _vm.checkGoodsList.length > 0
                    ? _c(
                        "div",
                        { staticStyle: { "margin-top": "20px" } },
                        [
                          _c("span", [_vm._v("已选")]),
                          _c("el-button", { attrs: { type: "text" } }, [
                            _vm._v(_vm._s(_vm.multipleSelection.length))
                          ]),
                          _c("span", { staticClass: "mar20-r" }, [
                            _vm._v("项")
                          ]),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary", plain: "" },
                              on: { click: _vm.deleteSel }
                            },
                            [_vm._v("删除")]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-dialog",
            {
              attrs: {
                title: "选择商品",
                visible: _vm.chooseGoodVisible,
                "close-on-click-modal": false,
                width: "1140px",
                top: "80px",
                "show-close": false,
                "custom-class": "chooseGoodPop"
              },
              on: {
                "update:visible": function($event) {
                  _vm.chooseGoodVisible = $event
                }
              }
            },
            [
              _c("div", [
                _c("div", { staticClass: "clear ps_search_wrap" }, [
                  _c(
                    "span",
                    { staticClass: "float-left pad15_r lin_30 inlineblock" },
                    [_vm._v("商品名称")]
                  ),
                  _c(
                    "div",
                    { staticClass: "ps_search float-left" },
                    [
                      _c("el-input", {
                        attrs: { type: "text", placeholder: "请输入商品名称" },
                        model: {
                          value: _vm.searchGoods.name,
                          callback: function($$v) {
                            _vm.$set(_vm.searchGoods, "name", $$v)
                          },
                          expression: "searchGoods.name"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "float-left client_pop_query" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.listShopGoods(1)
                            }
                          }
                        },
                        [_vm._v("搜索")]
                      )
                    ],
                    1
                  )
                ]),
                _c("div", { staticClass: "clear appoint_goods_list" }, [
                  _c("div", { staticClass: "float-left client_list_all" }, [
                    _c("p", [_vm._v("商品信息")]),
                    _c("div", { staticClass: "client_list_wrap" }, [
                      _c(
                        "ul",
                        { staticClass: "clear" },
                        _vm._l(_vm.goodsDataList, function(item, index) {
                          return _c(
                            "li",
                            {
                              key: index,
                              on: {
                                click: function($event) {
                                  return _vm.goodsDialogSelect(item)
                                }
                              }
                            },
                            [
                              _c("img", {
                                staticClass: "float-left appoint_good_img",
                                attrs: { src: item.picUrl, alt: "" }
                              }),
                              _c(
                                "div",
                                { staticClass: "float-left appoint_good_main" },
                                [
                                  _c("p", { staticClass: "ellipsis f14" }, [
                                    _vm._v(_vm._s(item.name))
                                  ]),
                                  _c("p", { staticClass: "f12" }, [
                                    _vm._v("规格：" + _vm._s(item.spec))
                                  ]),
                                  _c("p", { staticClass: "f12" }, [
                                    _vm._v(
                                      "原价：¥" + _vm._s(item.marketPriceStr)
                                    )
                                  ])
                                ]
                              )
                            ]
                          )
                        }),
                        0
                      )
                    ])
                  ]),
                  _c("div", { staticClass: "float-right client_list_me" }, [
                    _c("p", [_vm._v("已选商品")]),
                    _c("div", { staticClass: "client_list_wrap" }, [
                      _c(
                        "ul",
                        { staticClass: "clear" },
                        _vm._l(_vm.goodsSelectList, function(item, index) {
                          return _c("li", { key: index }, [
                            _c("i", {
                              staticClass: "iconfont icon-shibai fb",
                              on: {
                                click: function($event) {
                                  return _vm.removeSelectGoods(index)
                                }
                              }
                            }),
                            _c("img", {
                              staticClass: "float-left appoint_good_img",
                              attrs: { src: item.picUrl, alt: "" }
                            }),
                            _c(
                              "div",
                              { staticClass: "float-left appoint_good_main" },
                              [
                                _c("p", { staticClass: "ellipsis f14" }, [
                                  _vm._v(_vm._s(item.name))
                                ]),
                                _c("p", { staticClass: "f12" }, [
                                  _vm._v("规格：" + _vm._s(item.spec))
                                ]),
                                _c("p", { staticClass: "f12" }, [
                                  _vm._v(
                                    "原价：¥" + _vm._s(item.marketPriceStr)
                                  )
                                ])
                              ]
                            )
                          ])
                        }),
                        0
                      )
                    ])
                  ])
                ])
              ]),
              _c("div", { staticClass: "box10" }),
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "current-page": _vm.currentPage,
                  "page-sizes": [10, 20, 30],
                  "page-size": _vm.pageSize,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.totalCount
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange
                }
              }),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.goodsDialogConfirm }
                    },
                    [_vm._v("确 认")]
                  ),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.chooseGoodVisible = false
                        }
                      }
                    },
                    [_vm._v("取 消")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.showSelectCate
        ? _c("SelectCateDialog", {
            attrs: { showSelectCate: _vm.showSelectCate },
            on: {
              "update:showSelectCate": function($event) {
                _vm.showSelectCate = $event
              },
              "update:show-select-cate": function($event) {
                _vm.showSelectCate = $event
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }